import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import dataService from 'services/dataService';

import { showResult } from '../utils';
import { apiUrlGenerator } from '../use-api';

import type { IFilters } from 'infrastructure/interfaces';
import type { IPaginatedPatientBingoProgress } from 'infrastructure/interfaces/i-patient-bingo-progress';

interface IPaginationProps {
  page: number;
  items: number;
}

interface IUsePatientInfoProps {
  patientGuid: string;
  pagination: IPaginationProps;
}

const getPatientBingoProgressFn = async (
  patientGuid: string,
  filter: IFilters,
) => {
  const url = `admins/admin-panel/patients/${patientGuid}/bingoProgress`;

  const { data, error } =
    await dataService.getList<IPaginatedPatientBingoProgress>(
      apiUrlGenerator(url, filter),
    );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const getPatientBingoProgressKey = (
  patientGuid: string,
  pagination: IPaginationProps,
) => ['patientBingoProgress', patientGuid, pagination];

export const usePatientBingoProgress = (props: IUsePatientInfoProps) => {
  const filter: IPaginationProps = {
    ...props.pagination,
  };

  const { data, isLoading, isFetching, error } = useQuery<
    IPaginatedPatientBingoProgress | undefined,
    string | undefined
  >({
    queryKey: getPatientBingoProgressKey(props.patientGuid, filter),
    queryFn: async () => getPatientBingoProgressFn(props.patientGuid, filter),
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { data, isLoading, isFetching };
};
